import { FunctionComponent } from 'react';

import LayoutContainer from 'components/layout/LayoutContainer';
import ResultsHeader from 'components/modules/public/layout/jobs/ResultsHeader';
import ResultsList from 'components/modules/public/layout/jobs/ResultsList';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageOffersSectionList: FunctionComponent<Props> = ({
    header,
    list,
}) => {
    return (
        <StyledComponent className="public-page-offers-section-list">
            <LayoutContainer>
                <ResultsHeader {...header} />
                <ResultsList {...list} />
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageOffersSectionList;